import { render } from "./History.vue?vue&type=template&id=12b102b4&ts=true"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"

import "./History.vue?vue&type=style&index=0&id=12b102b4&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__